import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router-dom";
import SideDrawer from "../../Pages/ControlTower/SideDrawer/SideDrawer";
import "./MainContent.css";

 
const MainContent = (props) => {
  const dispatch = useDispatch();
 
  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, null, window.location.href);
    };
  }, [dispatch]);
 
  return (
    <div className="main-content">
      {/* Left Sidebar */}
      <SideDrawer contentHeight={props.contentHeight} />
 
      {/* Main Content Area */}
      <div className="content">
        <Outlet />
        
      </div>
    </div>
  );
};
 
export default MainContent;